// Generated by CoffeeScript 1.9.3
var MarginBottom, _Length,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

_Length = require('./_Length');

module.exports = MarginBottom = (function(superClass) {
  extend(MarginBottom, superClass);

  function MarginBottom() {
    return MarginBottom.__super__.constructor.apply(this, arguments);
  }

  return MarginBottom;

})(_Length);



//////////////////
// WEBPACK FOOTER
// ./~/renderkid/lib/renderKid/styles/rule/declarationBlock/MarginBottom.js
// module id = 393
// module chunks = 0